export const CURRENCY_SYMBOLS = {
  KRW: '₩',
  USD: '$',
  EUR: '€',
  JPY: '¥'
  // 기타 필요한 통화 기호 추가
};

export const USER_TYPE = {
  EMPLOYEE: { key: 'EMPLOYEE', name: 'user.type.employee' }, // 임직원
  NATIVE: { key: 'NATIVE', name: 'user.type.native' }, // 내국인
  FOREIGNER: { key: 'NATIVE', name: 'user.type.foreigner' } // 외국인
};

export const VISITOR_SECURITY_CARD_STATUS = {
  NONE: { key: 'NONE', name: 'None' },
  ASSIGNED: { key: 'ASSIGNED', name: 'visitor.security_card.status.assigned' },
  ISSUED: { key: 'ISSUED', name: 'visitor.security_card.status.issued' },
  RETURNED: { key: 'RETURNED', name: 'visitor.security_card.status.returned' },
  LOST: { key: 'LOST', name: 'visitor.security_card.status.lost' },
  DAMAGED: { key: 'DAMAGED', name: 'visitor.security_card.status.damaged' },
  LOSE_CANCELED: { key: 'LOSE_CANCELED', name: 'visitor.security_card.status.lose_canceled' },
  DAMAGE_CANCELED: { key: 'DAMAGE_CANCELED', name: 'visitor.security_card.status.damage_canceled' }
};
